import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { BoardTemplate, StatusTemplate } from "@onetasklist/shared";
import { BOARD_TEMPLATE_DEFINITIONS } from "@onetasklist/shared";

export const useResolvedBoardTemplates = (): BoardTemplate[] => {
  const { t } = useTranslation();

  return useMemo(
    () =>
      BOARD_TEMPLATE_DEFINITIONS.map((def) => ({
        id: def.templateId,
        templateId: def.templateId,
        title: t(def.titleKey),
        description: t(def.descriptionKey),
        iconUrl: def.iconUrl,
        statuses: def.statuses.map(
          (s): StatusTemplate => ({
            name: t(s.nameKey),
            isDone: s.isDone,
            colour: s.colour,
            statusId: s.statusId,
            ...(s.scheduleDateDays !== undefined && { scheduleDateDays: s.scheduleDateDays }),
          }),
        ),
      })),
    [t],
  );
};
